export default "__VITE_ASSET__BL0lV_xB__"